module.exports = __webpack_public_path__ + "img/maintanceimg.3eb86d0c.png";